import { render, staticRenderFns } from "./Preparacion.vue?vue&type=template&id=f044ac7a&scoped=true"
import script from "./Preparacion.vue?vue&type=script&lang=js"
export * from "./Preparacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f044ac7a",
  null
  
)

export default component.exports